import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a25298638ca120014ac00b8_1781947768856_046d4dc2/smartcontrax/src/app/error.tsx");
